import { render, staticRenderFns } from "./ExScrollBar.vue?vue&type=template&id=f12c81b8&scoped=true"
import script from "./ExScrollBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ExScrollBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ExScrollBar.vue?vue&type=style&index=0&id=f12c81b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12c81b8",
  null
  
)

export default component.exports